module.exports = __webpack_public_path__ + "static/educate-magis-fr-dbf99ffaaceeecd560d0e158e8f6da96.svg";